import { useEffect } from "react";
import { Link } from "react-router-dom";
import { usePageHeader } from "@/layout/usePageHeader";

export function NotFoundPage() {
  const { setPageMeta } = usePageHeader();

  useEffect(() => {
    setPageMeta({
      title: "Seite nicht gefunden",
      subtitle: "Diese Route gibt es in der React-Vorschau noch nicht.",
    });
    return () => setPageMeta(null);
  }, [setPageMeta]);

  return (
    <div className="rounded-ios-lg border border-dashed border-separator bg-card p-8 text-center shadow-ios">
      <p className="text-sm text-label-secondary">
        Diese Adresse gibt es in der App nicht. Bitte nutze die Navigation oder gehe zur
        Übersicht.
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-3 text-sm">
        <Link
          to="/"
          className="rounded-full bg-accent px-4 py-2 font-medium text-label-on-accent shadow-sm transition hover:bg-accent-hover"
        >
          Zurück zur Übersicht
        </Link>
      </div>
    </div>
  );
}
